var App = App || {};

App.WidgetIframeForm = (function ($) {
    'use strict';

    function resizeIframe(iframe) {
        try {
            const iframeDocument = iframe.contentWindow?.document;

            if (!iframeDocument) {
                return;
            }

            const bodyHeight = iframeDocument.body ? iframeDocument.body.scrollHeight : 0;
            const documentHeight = iframeDocument.documentElement ? iframeDocument.documentElement.scrollHeight : 0;

            iframe.style.height = `${Math.max(bodyHeight, documentHeight)}px`;
        } catch (error) {
            // Ignore cross-origin access errors.
        }
    }

    function Init(selector) {
        const iframes = selector.find("iframe");

        if (!iframes.length) {
            return;
        }

        const resizeAllIframes = function () {
            iframes.each(function () {
                resizeIframe(this);
            });
        };

        iframes.each(function () {
            const iframe = this;

            iframe.addEventListener("load", function () {
                resizeIframe(iframe);
            });

            if (iframe.contentWindow?.document?.readyState === "complete") {
                resizeIframe(iframe);
            }
        });

        let resizeTimeout;
        window.addEventListener("resize", function () {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(resizeAllIframes, 100);
        });
    }

    return {
        Init: Init
    };

})(jQuery);
